import React, { useContext } from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  makeStyles,
  Button,
  Avatar,
} from '@material-ui/core'

import HomeIcon from '@material-ui/icons/Home'
import AddIcon from '@material-ui/icons/Add'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { FirestoreContext } from '../../providers/firestore-provider'

interface IWebNavigationProps {
  onClickMenuItem: (pageURL: string, modal: boolean) => void
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      flexGrow: 1,
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
}))

export const WebNavigation = ({ onClickMenuItem }: IWebNavigationProps) => {
  const classes = useStyles()
  const { currentUser } = useContext(FirestoreContext)
  const menuItems = [
    {
      menuTitle: 'Home',
      pageURL: '/',
      icon: <HomeIcon style={{ color: '#FFFFFF' }} />,
      modal: false,
    },
    {
      menuTitle: 'Add Dose',
      pageURL: '/',
      icon: <AddIcon style={{ color: '#FFFFFF' }} />,
      modal: true,
    },
    {
      menuTitle: 'Profile',
      pageURL: '/profile',
      icon: currentUser?.photoURL ? (
        <Avatar
          alt="Remy Sharp"
          src={currentUser?.photoURL}
          className={classes.small}
        />
      ) : (
        <AccountCircle />
      ),

      modal: false,
    },
  ]

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Button
            variant="text"
            color="default"
            onClick={() => onClickMenuItem('/', false)}
          >
            <Typography
              className={classes.title}
              variant="h6"
              color="inherit"
              noWrap
              style={{ color: 'white' }}
            >
              The Daily Dose App
            </Typography>
          </Button>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            {menuItems.map((menuItem) => (
              <Tooltip title={menuItem.menuTitle} key={menuItem.menuTitle}>
                <IconButton
                  color="inherit"
                  onClick={() => onClickMenuItem(menuItem.pageURL, menuItem.modal)}
                >
                  {menuItem.icon}
                </IconButton>
              </Tooltip>
            ))}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}
